<template>
	<div class="org-picker" :style="styles">
		<div
			class="org-header"
			v-text="$t('chat_drawer_accountpicker_switchaccount')"
		/>
		<div class="org-account-list">
			<BasicUserPill
				v-for="acct in accounts"
				:key="acct.id"
				:profile="acct.organization"
				:mainText="acct.organization.name"
				:subText="`${acct.firstname} ${acct.lastname}`"
				:link="acct.origin"
				class="account-item"
				newTab
			>
				<div
					v-if="acct.isPreview"
					class="account-origin"
					v-text="acct.hostname"
				/>
			</BasicUserPill>
			<a
				class="add-account"
				:tabindex="open ? '0' : null"
				:href="newAccountLink"
				target="_blank"
				v-text="$t('chat_drawer_accountpicker_addaccount')"
			/>
		</div>
	</div>
</template>
<script>
import { BasicUserPill } from '../common'
import store from '@/store'
import { getLoginUrl, setDesktopLoginUrls } from '@/helperMethods'

const BASE_HEIGHT = 94
const USER_HEIGHT = 64
const USER_PREVIEW_HEIGHT = 75
const MAX_HEIGHT = 400

export default {
	name: 'AccountPicker',
	components: { BasicUserPill },
	props: {
		open: {
			type: Boolean,
			default: null,
		},
	},
	mounted() {
		setDesktopLoginUrls()
	},
	computed: {
		newAccountLink() {
			return getLoginUrl()
		},
		accounts() {
			return store
				.getActiveUsers()
				.filter((u) => u.id !== store.auth.user.id)
				.sort((a, b) => a.organization.name.localeCompare(b.organization.name))
		},
		styles() {
			const { open, accounts } = this
			const acctHeights = accounts
				.map((a) => (a.isPreview ? USER_PREVIEW_HEIGHT : USER_HEIGHT))
				.reduce((sum, h) => sum + h, 0)
			const fullHeight = acctHeights + BASE_HEIGHT
			const overflowed = fullHeight > MAX_HEIGHT
			return {
				height: open ? `${overflowed ? MAX_HEIGHT : fullHeight}px` : '0',
				'padding-top': open ? '8px' : '0',
				'padding-bottom': open ? '8px' : '0',
				overflow: overflowed ? 'auto' : 'hidden',
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';
$border: #d1d2d4;
$gray: #9498a3;

.org-picker {
	margin-top: -1px;
	padding-left: 8px;
	padding-right: 8px;
	transition: all 0.3s ease-in-out;
	transition-property: height, padding-top, padding-bottom;
}
.org-header {
	text-transform: uppercase;
	letter-spacing: 1px;
	font-family: Avenir Heavy;
	font-size: 12px;
	margin-bottom: 8px;
	color: $gray;
}
.add-account {
	display: block;
	cursor: pointer;
	font-size: 14px;
	padding: 8px 16px;
	text-align: center;
	border: 1px dashed $gray;
	color: $gray;
	border-radius: 5px;
	margin: 12px 0;
	text-decoration: none;
	&:hover {
		background: var(--neutral-200);
	}
}
.account-item {
	padding: 8px;
	margin-bottom: 8px;
	&:last-child {
		margin-bottom: 0;
	}
	&:hover {
		background: var(--neutral-200);
	}
	.account-origin {
		font-size: 12px;
		font-family: Avenir-Book;
		color: var(--neutral-500);
		@include ellipsis;
	}
}
</style>
